import { cardImageSources, type GenericCharacter } from './types'

export const genericMerlin: GenericCharacter = {
  id: 'generic-merlin',
  enabled: true,
  order: 2,
  displayName: 'Merlín',
  icon: '🧙',
  imageSources: cardImageSources('generic-merlin'),
  previewVideoSrc: '/videos/previews/generic-merlin.mp4',
}
